@if(loader)
{
<div class="spinner-container">
  <mat-progress-spinner diameter="25" mode="indeterminate"></mat-progress-spinner>
</div>
}
<div>
  @if(disabled && selectedTime) { <span>{{ selectedTime.format("HH:mm") | transliterate }}</span> }
  @if(!loader && anyValidTimes) {
  <div #mnuOptions class="timeSelector-app">
    <div class="timeOption" id="time{{t.text}}" *ngFor="let t of options"
         [ngClass]="
         { 'isValid': t.isValid && !t.collidingBooking,
         'collidingBooking': t.collidingBooking,
         'selected': t.isSelected && t.isValid,
         'selectable': t.isValid && !t.collidingBooking || overrideTimeLimits && !t.collidingBooking,
         'showOptions': t.showOptions}"
         (click)="onHourClick(t, $event)">
      @if(!t.showOptions) { <div>{{ t.text | transliterate }}</div> }
      @if(t.showOptions) { <div id="time{{t.text}}">{{ t.text | transliterate }}</div> }
      @if(t.showOptions) {
      <div class="suboption-panel">
        <div *ngFor="let option of t.options" class="timeOption" id="time{{t.text}}"
             [ngClass]="
       {'isValid': option.isValid && !option.collidingBooking,
       'collidingBooking': option.collidingBooking,
       'selected': option.isSelected,
       'selectable': option.isValid && !option.collidingBooking || overrideTimeLimits && !option.collidingBooking}"
             (click)="onTimeOptionClick(option, $event)">
          {{ option.text | transliterate }}
        </div>
      </div>
      }

      @if(t.showOptions) { <div class="suboption-backfill"></div> }
    </div>
  </div>
  }

  @if(!anyValidTimes && !loader && !isClosed && !isOneWay) { <div id="loader">{{ 'Intellitrailer.Component.TimePicker.NoAvailableTimes' | translate : 'No available times for date' }}</div> }
  @if(!anyValidTimes && !loader && !isClosed && isOneWay) { <div id="loader">{{ 'Intellitrailer.Component.TimePicker.StationIsFull' | translate : 'The station is fully booked at this time.' }}
                                                              </div> <p>{{ 'Intellitrailer.Component.TimePicker.StationIsFullMsg' | translate : 'Please select another time or choose a nearby station.' }}</p>}
  @if(!anyValidTimes && !loader && isClosed) { <div id="loader">{{ 'Intellitrailer.Component.TimePicker.StoreClosed' | translate : 'Sorry, the store is closed on this day.' }}</div> }
</div>
